import { IProjectStatus } from "@/interfaces";

export const PROJECT_STATUS: {
  intake: {
    draft: IProjectStatus;
    inApproval: IProjectStatus;
    onHold: IProjectStatus;
    canceled: IProjectStatus;
  };
  project: {
    active: IProjectStatus;
    complete: IProjectStatus;
    onHold: IProjectStatus;
    canceled: IProjectStatus;
  };
} = {
  intake: {
    draft: {
      id: "589b2ff4-f28b-4085-ad48-a73449c8655c",
      translationId: "projectStatus.intake.draft",
    },
    inApproval: {
      id: "5cd507fd-8e7a-431b-8347-e8df15bd1fbc",
      translationId: "projectStatus.intake.inApproval",
    },
    canceled: {
      id: "b29e7d67-e0f4-44da-bf11-51e6e5fc358b",
      translationId: "projectStatus.intake.canceled",
    },
    onHold: {
      id: "612ba60b-235a-4ff7-bfe2-f723467e13e5",
      translationId: "projectStatus.intake.onHold",
    },
  },
  project: {
    active: {
      id: "b67c4b83-888b-4638-81b3-5d4182252294",
      translationId: "projectStatus.project.active",
    },
    complete: {
      id: "f678bf75-d551-4a67-8f7e-77fc0271f2c0",
      translationId: "projectStatus.project.complete",
    },
    onHold: {
      id: "c0c6baba-4f21-4d87-83a9-2d98655c4b9f",
      translationId: "projectStatus.project.onHold",
    },
    canceled: {
      id: "2552e22e-b9c2-45f2-bbaf-f009eff3d566",
      translationId: "projectStatus.project.canceled",
    },
  },
};

export const PROJECT_STATUS_DICT = {
  [PROJECT_STATUS.intake.draft.id]: PROJECT_STATUS.intake.draft.translationId,
  [PROJECT_STATUS.intake.inApproval.id]:
    PROJECT_STATUS.intake.inApproval.translationId,
  [PROJECT_STATUS.intake.canceled.id]:
    PROJECT_STATUS.intake.canceled.translationId,
  [PROJECT_STATUS.intake.onHold.id]: PROJECT_STATUS.intake.onHold.translationId,
  [PROJECT_STATUS.project.active.id]:
    PROJECT_STATUS.project.active.translationId,
  [PROJECT_STATUS.project.complete.id]:
    PROJECT_STATUS.project.complete.translationId,
  [PROJECT_STATUS.project.onHold.id]:
    PROJECT_STATUS.project.onHold.translationId,
  [PROJECT_STATUS.project.canceled.id]:
    PROJECT_STATUS.project.canceled.translationId,
};
